import React from 'react';
import Img from 'gatsby-image';
import { PrismicHTMLParser } from 'components/PrismicHTMLParser';
import { PrismicLink } from 'components/PrismicLink';
import { LrButton } from 'components/LANDR/LrButton';
import { Heading } from 'components/LANDR/Heading';
import { Grid, GridRow, GridCol } from 'components/UI/Grid';
import {
    PrismicRichTextFieldType,
    PrismicKeyTextFieldType,
    PrismicTitleFieldType,
    PrismicLinkFieldType,
    SliceContext,
} from '../types';
import './CallToAction.scss';
import { SupportedPrismicSlicesEnum } from '../enums';

type CallToActionSlice = {
    slice_type: SupportedPrismicSlicesEnum.cta;
    primary: {
        call_to_action_theme: 'light' | 'dark';
        call_to_action_title: PrismicTitleFieldType;
        call_to_action_description: PrismicRichTextFieldType;
        call_to_action_label: PrismicKeyTextFieldType;
        call_to_action_link: PrismicLinkFieldType;
        call_to_action_background_image: {
            url: string | null;
            dimensions: {
                width: number;
                height: number;
            } | null;
        };
    };
};

type CallToActionProps = {
    slice: CallToActionSlice;
    sliceContext: SliceContext;
};

const CallToAction = ({ slice, sliceContext }: CallToActionProps) => {
    const { primary } = slice;
    return (
        <div className="CallToAction" data-theme={primary.call_to_action_theme}>
            <Grid>
                <GridRow horizontalAlign={'h-center'} verticalAlign={'v-center'}>
                    <GridCol colSize={`12`} offsetSize={`0`} mobileColSize={'12'}>
                        {(primary.call_to_action_title.raw ||
                            primary.call_to_action_description.html) && (
                            <div className="CallToAction-content">
                                {primary.call_to_action_title.raw && (
                                    <Heading
                                        className="CallToAction-title"
                                        size="mg"
                                        element={primary.call_to_action_title.raw[0].type}
                                    >
                                        {primary.call_to_action_title.raw[0].text}
                                    </Heading>
                                )}
                                {primary.call_to_action_description.html && (
                                    <PrismicHTMLParser className="CallToAction-description">
                                        {primary.call_to_action_description.html}
                                    </PrismicHTMLParser>
                                )}
                            </div>
                        )}
                        {primary.call_to_action_link && (
                            <PrismicLink
                                link={primary.call_to_action_link}
                                className="CallToAction-cta"
                                slice={sliceContext}
                            >
                                <LrButton variant="primary">
                                    {primary.call_to_action_label}
                                </LrButton>
                            </PrismicLink>
                        )}
                    </GridCol>
                </GridRow>
            </Grid>
            {/* TODO: Use Gatsby Image for the CTA background image */}
            {primary.call_to_action_background_image.dimensions && (
                <Img
                    className="CallToAction-background"
                    fixed={{
                        src: primary.call_to_action_background_image.url,
                        srcSet: '',
                        width: primary.call_to_action_background_image.dimensions.width,
                        height: primary.call_to_action_background_image.dimensions.height,
                    }}
                    alt={''}
                />
            )}
        </div>
    );
};

export { CallToAction, CallToActionProps };
